import { graphql } from 'gatsby'
import React from 'react'
import Layout from '../shared/components/organisms/layout/layout'
import useLocaleMode from '../shared/hooks/useLocaleMode'
import useMobileMode from '../shared/hooks/useMobileMode'
import SEO from './../shared/components/seo'
import './../shared/_shared/Index.scss'
import ConsultingContent from "../components/organisms/consulting-content/consulting-content";


const IndexPage = (props) => {

  const { locale } = useLocaleMode();
  const { isMobile } = useMobileMode();

  return (
    <Layout title={props.data.allContentfulTenaConsultorios.nodes[0].metaTitulo} isMobile={isMobile}>
      <SEO
        title={props.data.allContentfulTenaConsultorios.nodes[0].metaTitulo}
        description={props.data.allContentfulTenaConsultorios.nodes[0].metaDescripcion.metaDescripcion}
        image={props.data.allContentfulTenaConsultorios.nodes[0]?.banners?.bannerDesktop?.file.url}
        lang={locale}
      />
      <ConsultingContent mobile={isMobile} params={props.data.allContentfulTenaConsultorios.nodes[0]} />
    </Layout>
  )
};

export const query = graphql`
query GET_CONSULTING_CONTENT($language: String!) {
  allContentfulTenaConsultorios(filter: { node_locale: { eq: $language } }) {
    nodes {
      metaTitulo
      metaDescripcion {
        metaDescripcion
      }
      slug
      banners {
        bannerDesktop {
          description
          file {
            url
            details {
              image {
                height
              }
            }
          }
          fixed {
            base64
          }
        }
        bannerMobile {
          description
          file {
            url
            details {
              image {
                height
              }
            }
          }
          fixed {
            base64
          }
        }
        nombre
        descripcionImagen
        descripcionImagen2
      }
      beneficios {
        json
      }
      imagenMuyImportante {
        description
        file {
          url
          details {
            image {
              height
            }
          }
        }
        fixed {
          base64
        }
      }
      muyImportante {
        json
      }
      especialistas {
        slug
        nombreEspecialista
        nombreBotonEspecialista
        imagenDeEspecialistaHome {
          file {
            url
            details {
              image {
                height
              }
            }
          }
          fixed {
            base64
          }
          description
        }
        descripcionEspecialistaHome {
          json
        }
      }
    }
  }
}

`

export default IndexPage;
